var map = {
	"./Doctor1.svg": 99962,
	"./Download_07.svg": 96296,
	"./Download_Btn.svg": 77861,
	"./Referrals1.svg": 33935,
	"./Sales.svg": 85152,
	"./Vigo_logo.svg": 56933,
	"./act-event.svg": 52563,
	"./activity1.svg": 76076,
	"./agenda.svg": 49256,
	"./agent.svg": 29347,
	"./agents1.svg": 75559,
	"./alarm.svg": 3580,
	"./alert1.svg": 62383,
	"./alerts.svg": 15453,
	"./alertsSettings.svg": 35390,
	"./arrow.svg": 64539,
	"./basic-details.svg": 76395,
	"./battery-danger.svg": 62457,
	"./battery.svg": 10927,
	"./bed.svg": 74221,
	"./bot.svg": 92783,
	"./bp.svg": 27238,
	"./bp_alarm.svg": 19812,
	"./bp_blink.svg": 19721,
	"./bug.svg": 87454,
	"./business-p.svg": 11189,
	"./case1.svg": 82989,
	"./cases.svg": 78751,
	"./caution.svg": 77835,
	"./chart.svg": 40032,
	"./check-mark.svg": 43150,
	"./check-w.svg": 96144,
	"./check.svg": 49488,
	"./clients.svg": 10140,
	"./clipboard.svg": 84802,
	"./close.svg": 99964,
	"./cloud-error.svg": 29334,
	"./cloud-offline.svg": 905,
	"./cloud.svg": 51331,
	"./cloud1.svg": 79592,
	"./completed-case.svg": 49672,
	"./component.svg": 77541,
	"./condition.svg": 16231,
	"./customer-plan.svg": 85232,
	"./customer1.svg": 64833,
	"./dashboard.svg": 87532,
	"./dashboard1.svg": 94325,
	"./description.svg": 94014,
	"./device-instance.svg": 24470,
	"./devices.svg": 82337,
	"./devices1.svg": 53394,
	"./doctors.svg": 29144,
	"./documentation.svg": 51142,
	"./documents.svg": 52434,
	"./download.svg": 47032,
	"./drag.svg": 22774,
	"./ecg-group.svg": 87717,
	"./ecg_alarm.svg": 20789,
	"./edit-profile.svg": 16492,
	"./edit.svg": 21788,
	"./email.svg": 30032,
	"./email1.svg": 12273,
	"./employee.svg": 16008,
	"./employees.svg": 38747,
	"./event1.svg": 53329,
	"./example.svg": 30978,
	"./excel.svg": 67345,
	"./eye-close.svg": 62996,
	"./eye-open.svg": 35160,
	"./eye-view.svg": 33371,
	"./eye.svg": 97591,
	"./feedback.svg": 65117,
	"./feedback1.svg": 4950,
	"./female.svg": 61544,
	"./filter-applied.svg": 48790,
	"./filter-case.svg": 53275,
	"./flowerCircle.svg": 1181,
	"./form-builder-1.svg": 57426,
	"./form-builder.svg": 99580,
	"./form.svg": 57610,
	"./green-bp.svg": 79216,
	"./green-heart.svg": 7266,
	"./green-rr.svg": 45410,
	"./green-sc.svg": 82656,
	"./green-spo2.svg": 60192,
	"./green-temp.svg": 30904,
	"./grey-bp.svg": 36888,
	"./grey-heart.svg": 21034,
	"./grey-rr.svg": 81866,
	"./grey-sc.svg": 65928,
	"./grey-spo2.svg": 94776,
	"./grey-temp.svg": 91344,
	"./grid-view.svg": 58982,
	"./group1.svg": 85546,
	"./guide 2.svg": 85746,
	"./guide.svg": 81120,
	"./health1.svg": 18647,
	"./hr.svg": 40818,
	"./hr_blink.svg": 45917,
	"./hum-stand.svg": 80589,
	"./ic_search_24px.svg": 26044,
	"./information.svg": 61522,
	"./international.svg": 26164,
	"./invoices.svg": 82872,
	"./link.svg": 62936,
	"./list-view.svg": 69534,
	"./list.svg": 10096,
	"./live-monitoring.svg": 30325,
	"./live.svg": 93286,
	"./lock.svg": 1709,
	"./logocircle.svg": 88037,
	"./logout-new.svg": 92831,
	"./logout-ns.svg": 40910,
	"./logout.svg": 38858,
	"./logoutb.svg": 91204,
	"./low_charge.svg": 80829,
	"./male.svg": 89215,
	"./manufacture1.svg": 44472,
	"./mapdevice.svg": 56608,
	"./master.svg": 62842,
	"./medical-details.svg": 36124,
	"./meetings.svg": 22010,
	"./message.svg": 29389,
	"./mobile-app.svg": 16244,
	"./monitoring.svg": 57966,
	"./monitoring1.svg": 19155,
	"./more.svg": 16755,
	"./msg.svg": 5459,
	"./mycompany.svg": 91235,
	"./nav-dashboard.svg": 73684,
	"./nav-user.svg": 26849,
	"./nested.svg": 92705,
	"./notification.svg": 97285,
	"./offboarding.svg": 1503,
	"./office-push-pin.svg": 11827,
	"./offline.svg": 33741,
	"./orange-bp.svg": 73541,
	"./orange-heart.svg": 1993,
	"./orange-rr.svg": 28551,
	"./orange-sc.svg": 61113,
	"./orange-spo2.svg": 12289,
	"./orange-temp.svg": 47469,
	"./order1.svg": 64801,
	"./organizers.svg": 35362,
	"./packages.svg": 71115,
	"./participants.svg": 76382,
	"./partners.svg": 41889,
	"./partners1.svg": 8626,
	"./password.svg": 20731,
	"./pat-alarm.svg": 51383,
	"./pat-info.svg": 87356,
	"./pat-msg.svg": 48811,
	"./pat-report.svg": 29846,
	"./patch1.svg": 56527,
	"./patient-check.svg": 6364,
	"./patient-ecg.svg": 49343,
	"./patients.svg": 50818,
	"./pdf.svg": 84738,
	"./pin.svg": 59317,
	"./plan1.svg": 64154,
	"./platform-partner.svg": 15124,
	"./pre-monitoring.svg": 35442,
	"./preview.svg": 45484,
	"./print.svg": 18733,
	"./print1.svg": 53446,
	"./products.svg": 89388,
	"./pulse.svg": 34291,
	"./pulse_alarm.svg": 53725,
	"./pulse_blink.svg": 20480,
	"./question.svg": 28660,
	"./questions.svg": 68063,
	"./recording.svg": 45537,
	"./red-bp.svg": 92212,
	"./red-heart.svg": 81774,
	"./red-rr.svg": 64614,
	"./red-sc.svg": 34404,
	"./red-spo2.svg": 23100,
	"./red-temp.svg": 40308,
	"./refdata.svg": 40015,
	"./report_wait.svg": 18218,
	"./roles.svg": 16587,
	"./rr.svg": 93876,
	"./rr_blink.svg": 65783,
	"./rupee.svg": 14575,
	"./settings.svg": 78415,
	"./signal.svg": 75596,
	"./size.svg": 36979,
	"./spo2.svg": 99710,
	"./spo2_alarm.svg": 90028,
	"./spo2_blink.svg": 78833,
	"./star.svg": 99336,
	"./storage.svg": 2179,
	"./subscriptions.svg": 80674,
	"./support.svg": 36285,
	"./system1.svg": 40904,
	"./table.svg": 19212,
	"./tablet-icon-low.svg": 67727,
	"./tablet-icon.svg": 81258,
	"./tasks.svg": 3894,
	"./temp.svg": 15338,
	"./temp_alarm.svg": 45824,
	"./temp_blink.svg": 60325,
	"./template.svg": 84654,
	"./templates.svg": 81649,
	"./toggle-back.svg": 4052,
	"./toggle-out.svg": 6919,
	"./transgender.svg": 40857,
	"./tree.svg": 91024,
	"./user.svg": 80681,
	"./users.svg": 73704,
	"./users1.svg": 69593,
	"./v-hr.svg": 7229,
	"./v-spo2.svg": 25625,
	"./v-temp.svg": 89381,
	"./vendors.svg": 45733,
	"./vendors1.svg": 35534,
	"./video-call.svg": 10338,
	"./video_call.svg": 16460,
	"./vigoLogo.svg": 224,
	"./vitals.svg": 25289,
	"./wallet.svg": 7479,
	"./wifi.svg": 32463,
	"./workflow-1.svg": 51145,
	"./workflow.svg": 38367,
	"./yellow-bp.svg": 76039,
	"./yellow-heart.svg": 5671,
	"./yellow-rr.svg": 75173,
	"./yellow-sc.svg": 54167,
	"./yellow-spo2.svg": 40003,
	"./yellow-temp.svg": 74635,
	"./zip.svg": 31029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;